import React from 'react';
import css from "./SecThree.module.scss";
import {useTranslation} from "react-i18next";

const SecThree = () => {

    const {t} = useTranslation();

    return (
        <section className={css.three}>
            <div className={css.main}>
                <div className={css.up}>
                    <p>{t("servDesAim")}</p>
                    <p>{t("servDesResearch")}</p>
                    <p>{t("servDesBrainstorming")}</p>
                    <p>{t("servDesPrototypeCreation")}</p>
                    <p>{t("servDesBrainstorming")}</p>
                    <p>{t("servDesOptions")}</p>
                    <p>{t("servDes")}</p>
                </div>
                <div className={css.down}>
                    <p>1</p>
                    <span>----------</span>
                    <p>2</p>
                    <span>---------------</span>
                    <p>3</p>
                    <span>--------------------</span>
                    <p>4</p>
                    <span>--------------------</span>
                    <p>5</p>
                    <span>-----------------</span>
                    <p>6</p>
                    <span>--------------------</span>
                    <p>7</p>
                </div>
            </div>
        </section>
    );
};

export default SecThree;